//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../no/ugmath.js";
let d=[[[0,"AutoCloseOption",1,0],[0,"HasHorizontalRails",1,0],[0,"PostType",1,0]],[[["partCharx"],"SetHandrailPartCharx",{},1,0],[["postLocation"],"PlaceHandrail",{},1,0],[[],"ReverseLastPost",{},0,0]],[]];
SPLM.Routing.HandrailBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.HandrailBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.HandrailBuilder.PostTypes = Object.freeze({
    "Start" : "Start", "Intermediate" : "Intermediate", "None" : "None", "End" : "End"});

export default SPLM;